
import React, { useEffect, useState } from "react";
import {
  FaSearch,
  FaCheckCircle,
  FaTimes,
  FaArrowLeft,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./CountrySelector.css";

/* =========================================================
   COUNTRY SELECTOR TRANSLATIONS - 30 LANGUAGES
========================================================= */

const countrySelectorTranslations = {
  en: {
    back: "Back",
    selectCountry: "Select Country",
    searchCountryCurrency: "Search country or currency...",
    closeCountrySelector: "Close country selector",
    clearSearch: "Clear search",
    noCountryFound: "No country found.",
    tryAnotherCountryCurrency: "Try another country or currency.",
  },
  fr: {
    back: "Retour",
    selectCountry: "Sélectionner un pays",
    searchCountryCurrency: "Rechercher un pays ou une devise...",
    closeCountrySelector: "Fermer la sélection du pays",
    clearSearch: "Effacer la recherche",
    noCountryFound: "Aucun pays trouvé.",
    tryAnotherCountryCurrency: "Essayez un autre pays ou une autre devise.",
  },
  sw: {
    back: "Rudi",
    selectCountry: "Chagua Nchi",
    searchCountryCurrency: "Tafuta nchi au sarafu...",
    closeCountrySelector: "Funga sehemu ya kuchagua nchi",
    clearSearch: "Futa utafutaji",
    noCountryFound: "Hakuna nchi iliyopatikana.",
    tryAnotherCountryCurrency: "Jaribu nchi au sarafu nyingine.",
  },
  pt: {
    back: "Voltar",
    selectCountry: "Selecionar país",
    searchCountryCurrency: "Pesquisar país ou moeda...",
    closeCountrySelector: "Fechar seleção de país",
    clearSearch: "Limpar pesquisa",
    noCountryFound: "Nenhum país encontrado.",
    tryAnotherCountryCurrency: "Tente outro país ou moeda.",
  },
  es: {
    back: "Volver",
    selectCountry: "Seleccionar país",
    searchCountryCurrency: "Buscar país o moneda...",
    closeCountrySelector: "Cerrar selector de país",
    clearSearch: "Borrar búsqueda",
    noCountryFound: "No se encontró ningún país.",
    tryAnotherCountryCurrency: "Prueba con otro país o moneda.",
  },
  ar: {
    back: "رجوع",
    selectCountry: "اختر الدولة",
    searchCountryCurrency: "ابحث عن دولة أو عملة...",
    closeCountrySelector: "إغلاق اختيار الدولة",
    clearSearch: "مسح البحث",
    noCountryFound: "لم يتم العثور على دولة.",
    tryAnotherCountryCurrency: "جرّب دولة أو عملة أخرى.",
  },
  zh: {
    back: "返回",
    selectCountry: "选择国家",
    searchCountryCurrency: "搜索国家或货币...",
    closeCountrySelector: "关闭国家选择器",
    clearSearch: "清除搜索",
    noCountryFound: "未找到国家。",
    tryAnotherCountryCurrency: "请尝试其他国家或货币。",
  },
  hi: {
    back: "वापस",
    selectCountry: "देश चुनें",
    searchCountryCurrency: "देश या मुद्रा खोजें...",
    closeCountrySelector: "देश चयन बंद करें",
    clearSearch: "खोज साफ़ करें",
    noCountryFound: "कोई देश नहीं मिला।",
    tryAnotherCountryCurrency: "कोई दूसरा देश या मुद्रा आज़माएँ।",
  },
  bn: {
    back: "ফিরে যান",
    selectCountry: "দেশ নির্বাচন করুন",
    searchCountryCurrency: "দেশ বা মুদ্রা খুঁজুন...",
    closeCountrySelector: "দেশ নির্বাচন বন্ধ করুন",
    clearSearch: "অনুসন্ধান মুছুন",
    noCountryFound: "কোনো দেশ পাওয়া যায়নি।",
    tryAnotherCountryCurrency: "অন্য দেশ বা মুদ্রা চেষ্টা করুন।",
  },
  ru: {
    back: "Назад",
    selectCountry: "Выберите страну",
    searchCountryCurrency: "Поиск страны или валюты...",
    closeCountrySelector: "Закрыть выбор страны",
    clearSearch: "Очистить поиск",
    noCountryFound: "Страна не найдена.",
    tryAnotherCountryCurrency: "Попробуйте другую страну или валюту.",
  },
  de: {
    back: "Zurück",
    selectCountry: "Land auswählen",
    searchCountryCurrency: "Land oder Währung suchen...",
    closeCountrySelector: "Länderauswahl schließen",
    clearSearch: "Suche löschen",
    noCountryFound: "Kein Land gefunden.",
    tryAnotherCountryCurrency: "Versuche ein anderes Land oder eine andere Währung.",
  },
  it: {
    back: "Indietro",
    selectCountry: "Seleziona paese",
    searchCountryCurrency: "Cerca paese o valuta...",
    closeCountrySelector: "Chiudi selezione paese",
    clearSearch: "Cancella ricerca",
    noCountryFound: "Nessun paese trovato.",
    tryAnotherCountryCurrency: "Prova un altro paese o un'altra valuta.",
  },
  nl: {
    back: "Terug",
    selectCountry: "Land selecteren",
    searchCountryCurrency: "Zoek land of valuta...",
    closeCountrySelector: "Landselectie sluiten",
    clearSearch: "Zoekopdracht wissen",
    noCountryFound: "Geen land gevonden.",
    tryAnotherCountryCurrency: "Probeer een ander land of een andere valuta.",
  },
  tr: {
    back: "Geri",
    selectCountry: "Ülke Seç",
    searchCountryCurrency: "Ülke veya para birimi ara...",
    closeCountrySelector: "Ülke seçiciyi kapat",
    clearSearch: "Aramayı temizle",
    noCountryFound: "Ülke bulunamadı.",
    tryAnotherCountryCurrency: "Başka bir ülke veya para birimi deneyin.",
  },
  ja: {
    back: "戻る",
    selectCountry: "国を選択",
    searchCountryCurrency: "国または通貨を検索...",
    closeCountrySelector: "国選択を閉じる",
    clearSearch: "検索をクリア",
    noCountryFound: "国が見つかりません。",
    tryAnotherCountryCurrency: "別の国または通貨をお試しください。",
  },
  ko: {
    back: "뒤로",
    selectCountry: "국가 선택",
    searchCountryCurrency: "국가 또는 통화 검색...",
    closeCountrySelector: "국가 선택 닫기",
    clearSearch: "검색 지우기",
    noCountryFound: "국가를 찾을 수 없습니다.",
    tryAnotherCountryCurrency: "다른 국가 또는 통화를 시도하세요.",
  },
  vi: {
    back: "Quay lại",
    selectCountry: "Chọn quốc gia",
    searchCountryCurrency: "Tìm quốc gia hoặc tiền tệ...",
    closeCountrySelector: "Đóng trình chọn quốc gia",
    clearSearch: "Xóa tìm kiếm",
    noCountryFound: "Không tìm thấy quốc gia.",
    tryAnotherCountryCurrency: "Hãy thử quốc gia hoặc tiền tệ khác.",
  },
  th: {
    back: "กลับ",
    selectCountry: "เลือกประเทศ",
    searchCountryCurrency: "ค้นหาประเทศหรือสกุลเงิน...",
    closeCountrySelector: "ปิดตัวเลือกประเทศ",
    clearSearch: "ล้างการค้นหา",
    noCountryFound: "ไม่พบประเทศ",
    tryAnotherCountryCurrency: "ลองประเทศหรือสกุลเงินอื่น",
  },
  id: {
    back: "Kembali",
    selectCountry: "Pilih Negara",
    searchCountryCurrency: "Cari negara atau mata uang...",
    closeCountrySelector: "Tutup pemilih negara",
    clearSearch: "Hapus pencarian",
    noCountryFound: "Negara tidak ditemukan.",
    tryAnotherCountryCurrency: "Coba negara atau mata uang lain.",
  },
  ms: {
    back: "Kembali",
    selectCountry: "Pilih Negara",
    searchCountryCurrency: "Cari negara atau mata wang...",
    closeCountrySelector: "Tutup pemilih negara",
    clearSearch: "Kosongkan carian",
    noCountryFound: "Negara tidak ditemui.",
    tryAnotherCountryCurrency: "Cuba negara atau mata wang lain.",
  },
  ur: {
    back: "واپس",
    selectCountry: "ملک منتخب کریں",
    searchCountryCurrency: "ملک یا کرنسی تلاش کریں...",
    closeCountrySelector: "ملک کا انتخاب بند کریں",
    clearSearch: "تلاش صاف کریں",
    noCountryFound: "کوئی ملک نہیں ملا۔",
    tryAnotherCountryCurrency: "کوئی دوسرا ملک یا کرنسی آزمائیں۔",
  },
  fa: {
    back: "بازگشت",
    selectCountry: "انتخاب کشور",
    searchCountryCurrency: "جستجوی کشور یا ارز...",
    closeCountrySelector: "بستن انتخاب کشور",
    clearSearch: "پاک کردن جستجو",
    noCountryFound: "کشوری پیدا نشد.",
    tryAnotherCountryCurrency: "کشور یا ارز دیگری را امتحان کنید.",
  },
  ha: {
    back: "Koma baya",
    selectCountry: "Zaɓi Ƙasa",
    searchCountryCurrency: "Nemo ƙasa ko kuɗi...",
    closeCountrySelector: "Rufe zaɓin ƙasa",
    clearSearch: "Share bincike",
    noCountryFound: "Ba a sami ƙasa ba.",
    tryAnotherCountryCurrency: "Gwada wata ƙasa ko kuɗi.",
  },
  yo: {
    back: "Pada",
    selectCountry: "Yan Orílẹ̀-èdè",
    searchCountryCurrency: "Wa orílẹ̀-èdè tàbí owó...",
    closeCountrySelector: "Pa yíyan orílẹ̀-èdè",
    clearSearch: "Pa àwárí rẹ́",
    noCountryFound: "A kò rí orílẹ̀-èdè kankan.",
    tryAnotherCountryCurrency: "Gbìyànjú orílẹ̀-èdè tàbí owó mìíràn.",
  },
  zu: {
    back: "Emuva",
    selectCountry: "Khetha Izwe",
    searchCountryCurrency: "Sesha izwe noma imali...",
    closeCountrySelector: "Vala ukukhetha izwe",
    clearSearch: "Sula usesho",
    noCountryFound: "Alikho izwe elitholekile.",
    tryAnotherCountryCurrency: "Zama elinye izwe noma imali.",
  },
  am: {
    back: "ተመለስ",
    selectCountry: "አገር ይምረጡ",
    searchCountryCurrency: "አገር ወይም ምንዛሬ ይፈልጉ...",
    closeCountrySelector: "የአገር ምርጫን ዝጋ",
    clearSearch: "ፍለጋን አጽዳ",
    noCountryFound: "ምንም አገር አልተገኘም።",
    tryAnotherCountryCurrency: "ሌላ አገር ወይም ምንዛሬ ይሞክሩ።",
  },
  so: {
    back: "Dib u noqo",
    selectCountry: "Dooro Dalka",
    searchCountryCurrency: "Raadi dal ama lacag...",
    closeCountrySelector: "Xir doorashada dalka",
    clearSearch: "Nadiifi raadinta",
    noCountryFound: "Dal lama helin.",
    tryAnotherCountryCurrency: "Isku day dal ama lacag kale.",
  },
  rw: {
    back: "Subira inyuma",
    selectCountry: "Hitamo Igihugu",
    searchCountryCurrency: "Shakisha igihugu cyangwa ifaranga...",
    closeCountrySelector: "Funga ahatoranyirizwa igihugu",
    clearSearch: "Siba ibyo washakishije",
    noCountryFound: "Nta gihugu cyabonetse.",
    tryAnotherCountryCurrency: "Gerageza ikindi gihugu cyangwa ifaranga.",
  },
  lg: {
    back: "Ddayo",
    selectCountry: "Londa Eggwanga",
    searchCountryCurrency: "Noonya eggwanga oba ssente...",
    closeCountrySelector: "Ggalawo okulonda eggwanga",
    clearSearch: "Sangula okunoonya",
    noCountryFound: "Tewali ggwanga liziddwa.",
    tryAnotherCountryCurrency: "Gezaako eggwanga oba ssente endala.",
  },
  af: {
    back: "Terug",
    selectCountry: "Kies Land",
    searchCountryCurrency: "Soek land of geldeenheid...",
    closeCountrySelector: "Maak landkeuse toe",
    clearSearch: "Vee soektog uit",
    noCountryFound: "Geen land gevind nie.",
    tryAnotherCountryCurrency: "Probeer 'n ander land of geldeenheid.",
  },
};

/* =========================================================
   COUNTRIES
========================================================= */

const countries = [
  { name: "Tanzania", flag: "🇹🇿", currency: "TZS", rate: 1, minAmount: 1000 },
  { name: "Kenya", flag: "🇰🇪", currency: "KES", rate: 129.50, minAmount: 1000 },
  { name: "Uganda", flag: "🇺🇬", currency: "UGX", rate: 3725, minAmount: 10000 },
  { name: "Rwanda", flag: "🇷🇼", currency: "RWF", rate: 1415, minAmount: 5000 },
  { name: "Burundi", flag: "🇧🇮", currency: "BIF", rate: 2920, minAmount: 10000 },
 
  { name: "Zambia", flag: "🇿🇲", currency: "ZMW", rate: 25.70, minAmount: 100 },
  { name: "Botswana", flag: "🇧🇼", currency: "BWP", rate: 13.70, minAmount: 50 },
  { name: "Madagascar", flag: "🇲🇬", currency: "MGA", rate: 4550, minAmount: 10000 },
  { name: "Malawi", flag: "🇲🇼", currency: "MWK", rate: 1745, minAmount: 10000 },
  { name: "Mozambique", flag: "🇲🇿", currency: "MZN", rate: 64, minAmount: 100 },
  { name: "South Sudan", flag: "🇸🇸", currency: "SSP", rate: 5200, minAmount: 10000 },
  { name: "Zimbabwe", flag: "🇿🇼", currency: "USD", rate: 1, minAmount: 10 },
];

/* =========================================================
   COUNTRY SELECTOR
========================================================= */

export default function CountrySelector({
  selected = null,
  onSelect = () => {},
  onClose = () => {},
}) {
  const [search, setSearch] = useState("");
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  const navigate = useNavigate();
  const t =
    countrySelectorTranslations[language] ||
    countrySelectorTranslations.en;

  /* UPDATE LANGUAGE WHEN IT CHANGES */
  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const searchValue = search.trim().toLowerCase();

  const filteredCountries = countries.filter((country) => {
    return (
      country.name.toLowerCase().includes(searchValue) ||
      country.currency.toLowerCase().includes(searchValue)
    );
  });

  const handleSelect = (country) => {
    if (typeof onSelect === "function") {
      onSelect(country);
    }

    if (typeof onClose === "function") {
      onClose();
    }

    if (country.name === "Tanzania") {
      navigate("/deposittzmobile", {
        state: { country },
      });
      return;
    }

    navigate("/deposit-express", {
      state: { country },
    });
  };

  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleBack = () => {
    if (typeof onClose === "function") {
      onClose();
    }

    navigate(-1);
  };

  const clearSearch = () => {
    setSearch("");
  };

  return (
    <div className="country-overlay" onClick={handleClose}>
      <div
        className="country-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-bar" />

        <button
          type="button"
          className="country-back-btn"
          onClick={handleBack}
        >
          <FaArrowLeft />
          <span>{t.back}</span>
        </button>

        <div className="modal-header">
          <h2>{t.selectCountry}</h2>

          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
            aria-label={t.closeCountrySelector}
          >
            <FaTimes />
          </button>
        </div>

        <div className="search-box">
          <FaSearch className="search-icon" />

          <input
            type="text"
            placeholder={t.searchCountryCurrency}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
            aria-label={t.searchCountryCurrency}
          />

          {search.length > 0 && (
            <button
              type="button"
              className="search-clear"
              onClick={clearSearch}
              aria-label={t.clearSearch}
            >
              <FaTimes />
            </button>
          )}
        </div>

        <div className="country-list">
          {filteredCountries.map((country) => {
            const isSelected =
              selected?.currency === country.currency;

            return (
              <button
                type="button"
                key={country.currency}
                className={
                  isSelected
                    ? "country-item selected"
                    : "country-item"
                }
                onClick={() => handleSelect(country)}
              >
                <div className="country-left">
                  <span className="flag">{country.flag}</span>

                  <div className="country-info">
                    <div className="country-name">
                      {country.name}
                    </div>

                    <div className="country-code">
                      {country.currency}
                    </div>
                  </div>
                </div>

                <div className="country-right">
                  {isSelected && (
                    <FaCheckCircle className="check" />
                  )}
                </div>
              </button>
            );
          })}

          {filteredCountries.length === 0 && (
            <div className="no-country">
              <div className="no-country-icon">🔍</div>
              <div>{t.noCountryFound}</div>
              <small>{t.tryAnotherCountryCurrency}</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

